import apiUtils from '@utils/apiUtils';
import { apiConstants } from '@utils/constants';
import { fetchAPI } from '@api/apiServiceHelper';

const defaultGetParam = apiUtils.getDefaultGetParams();

let api = {
    get: ({
        offset = defaultGetParam.offset,
        limit = defaultGetParam.limit,
        filter,
        sort = '',
        orderTypes = 'DYNAMIC',
    }) => {
        return fetchAPI.getList(
            `${apiConstants.BASE_URL}/api/order/report/reconciliation/tm`,
            apiUtils.normalizeQueryParams({
                ...filter,
                limit,
                offset,
                sort,
                orderTypes,
                reportItemPerOrderPartner: true,
            })
        );
    },
};

export default api;
